module.exports = __webpack_public_path__ + "static/media/particle.f0c0d180.png";